import React from "react";
import Chip from "@mui/material/Chip";
import classNames from "classnames";
import "./tag.scss";

export const Tag = ({ text, variant, className, ...props }) => {
  return (
    <Chip
      className={classNames("tag-wrapper", variant, className)}
      label={text}
      {...props}
    />
  );
};
